/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Generate_TextInputs */

const cs_enum_generate_text = /** @type {(inputs: Enum_Generate_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generování textu`)
};

const en_enum_generate_text = /** @type {(inputs: Enum_Generate_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate text`)
};

/**
* | output |
* | --- |
* | "Generate text" |
*
* @param {Enum_Generate_TextInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_generate_text = /** @type {((inputs?: Enum_Generate_TextInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Generate_TextInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_generate_text(inputs)
	return cs_enum_generate_text(inputs)
});